import { makeStyles, tokens } from '@fluentui/react-components';

const badgeTextStyles = {
  fontFamily: tokens.fontFamilyBase,
  fontWeight: tokens.fontWeightSemibold,
  fontSize: tokens.fontSizeBase200,
  lineHeight: tokens.lineHeightBase200,
};

export const useStatusBadgeStyles = makeStyles({
  baseBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '6px',
    ...badgeTextStyles,
  },
  neutralBadge: {
    backgroundColor: tokens.colorNeutralBackground4,
    color: tokens.colorNeutralForeground2,
    border: `1px ${tokens.colorNeutralStroke2}`,
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    ...badgeTextStyles,
  },
  successBadge: {
    backgroundColor: tokens.colorPaletteGreenBackground1,
    color: tokens.colorPaletteGreenForeground1,
    border: `1px ${tokens.colorPaletteGreenBorder1}`,
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    ...badgeTextStyles,
  },
  pendingBadge: {
    backgroundColor: tokens.colorStatusWarningBackground1,
    color: tokens.colorStatusWarningForeground1,
    border: `1px ${tokens.colorStatusWarningBorder1}`,
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    ...badgeTextStyles,
  },
  blockedBadge: {
    backgroundColor: tokens.colorStatusDangerBackground1,
    color: tokens.colorStatusDangerForeground1,
    border: `1px ${tokens.colorStatusDangerBorder1}`,
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    ...badgeTextStyles,
  },
});
